// External API configuration
// Backend provides the correct API URL via _api_uri variable
// For local development: use localStorage to switch to dev API
// - To use dev API: localStorage.setItem('useDevApi', 'true')
// - To use local API: localStorage.removeItem('useDevApi')
const useDevApi = typeof window !== 'undefined' && localStorage.getItem('useDevApi') === 'true';
const backendApiUrl = window.serverData?.apiBaseUrl;
const devUrl = window.serverData?.apiBaseUrlDev;

// Priority: localStorage override (for local dev) > backend URL > fallback to dev
export const API_BASE_URL =
	useDevApi && devUrl ? devUrl : backendApiUrl || 'https://api-dev.holdshort.com/api/v1';

// Static assets base URL (for avatars, images, etc.)
// On local or dev: always use dev.holdshort.com for static files
// On staging/production: use the current domain
const hostname = typeof window !== 'undefined' ? window.location?.hostname : '';
const isLocalOrDev = hostname.includes('local.') || hostname.includes('dev.');
const isTest = hostname.includes('test.');
const appBaseUrl = typeof window !== 'undefined' ? window.serverData?._uri : '';
const spacesUrl = typeof window !== 'undefined' ? window.serverData?._spaces_url : '';
export const STATIC_BASE_URL =
	isLocalOrDev || !appBaseUrl ? 'https://dev.holdshort.com' : appBaseUrl;
export const STATIC_SPACE_URL = spacesUrl;

// Training module URL based on environment
export const TRAINING_URL = isLocalOrDev
	? 'https://training-dev.holdshort.com'
	: isTest
		? 'https://training-test.holdshort.com'
		: 'https://training.holdshort.com';
